export const PRIMARY_FONT = `'Gilda Display', serif;`;
export const SECONDARY_FONT = `'Della Respira', serif;`;
export const FANTASY = PRIMARY_FONT;
export const CURSIVE = PRIMARY_FONT;
